import React from "react";
import styled from "styled-components";
import ChatModal from "../../GalleryView/Agm/ChatModal";

const Index = ({
  isModalOpen,
  isBigScreen,
  src,
  modal,
  setModal,
  eventId,
  communicateFields,
}) => {
  return (
    <PageWrapper isModalOpen={isModalOpen}>
      <VideoContainer isBigScreen={isBigScreen}>
        <StyledIframe
          title="Digital Event"
          src={src}
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          allowFullScreen
        />
      </VideoContainer>

      {modal?.state && (
        <ModalWrapper>
          <ChatModal {...{ modal, setModal, eventId, communicateFields }} />
        </ModalWrapper>
      )}
    </PageWrapper>
  );
};

export default Index;

const PageWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: ${(props) => (props.isModalOpen ? "flex-start" : "center")};
  align-items: flex-start;
  gap: 20px;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
`;

const VideoContainer = styled.div`
  position: relative;
  height: 0;
  overflow: hidden;
  width: ${(props) => (props.isBigScreen ? "60%" : "89%")};
  padding-bottom: ${(props) =>
    props.isBigScreen ? "45%" : "56.25%"}; /* 16:9 ratio */

  @media (max-width: 600px) {
    width: 100%;
    padding-bottom: 56.25%;
  }
`;

const ModalWrapper = styled.div`
  width: 40%;

  @media (max-width: 600px) {
    width: 100%;
  }
`;

const StyledIframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  //border-radius: 12px;
  background: #000; 
`;

export const theme = {
  breakpoints: {
    sm: "600px",
    md: "960px",
    lg: "1280px",
    xl: "1920px",
  },
};
